
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/services/jet-one-suites",
      function () {
        return require("private-next-pages/services/jet-one-suites/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/services/jet-one-suites"])
      });
    }
  